import geofenceList from 'Modules/realtimeMaps/main/components/geofences/components/geofenceList/lan/en';
import geofenceCreateEdit from 'Modules/realtimeMaps/main/components/geofences/components/geofenceCreateEdit/lan/en';
import geofenceGroupCreateEdit from 'Modules/realtimeMaps/main/components/geofences/components/geofenceGroupCreateEdit/lan/en';
import geofenceSettings from 'Modules/realtimeMaps/main/components/geofences/components/geofenceSetting/lan/en';
import geofenceSettingsViewGeo from 'Modules/realtimeMaps/main/components/geofences/components/geofenceSettingsViewGeo/lan/en';
import geofenceDelete from 'Modules/realtimeMaps/main/components/geofences/components/geofenceDelete/lan/en';
import geofenceGroupDelete from 'Modules/realtimeMaps/main/components/geofences/components/geofenceGroupDelete/lan/en';
import geofenceSettingsViewUnits from 'Modules/realtimeMaps/main/components/geofences/components/geofenceSettingsViewUnits/lan/en';
import geofenceContacts from 'Modules/realtimeMaps/main/components/geofences/components/geofenceContacts/lan/en';
import geofenceAssign from 'Modules/realtimeMaps/main/components/geofences/components/geofenceAssign/lan/en';
import geofenceBulk from 'Modules/realtimeMaps/main/components/geofences/components/geofenceBulk/lan/en';
import geofenceVisibleTags from 'Modules/realtimeMaps/main/components/geofences/components/geofenceVisibleTags/lan/en';

export default {
    ...geofenceList,
    ...geofenceCreateEdit,
    ...geofenceGroupCreateEdit,
    ...geofenceSettings, 
    ...geofenceSettingsViewGeo,
    ...geofenceDelete,
    ...geofenceGroupDelete,
    ...geofenceSettingsViewUnits,
    ...geofenceContacts,
    ...geofenceAssign,
    ...geofenceBulk,
    ...geofenceVisibleTags
};